<!--
 * @Author: tony.zhu
 * @Date: 2025-09-26 11:01:22
 * @LastEditTime: 2025-11-04 18:19:11
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-textarea_one">
    <el-input
      :type="$attrs.type !== undefined ? $attrs.type : 'textarea'"
      autofocus="true"
      @keydown.native="onKeyCode($event)"
      resize="none"
      v-model="value"
      :maxlength="$attrs.maxlength"
      :autosize="
        $attrs.autosize != undefined
          ? $attrs.autosize
          : { minRows: 1, maxRows: 4 }
      "
      :placeholder="$attrs.placeholder || `Ctrl+Enter换行`"
      ref="customInput"
      class="c-template_input"
      @focus="
        () => {
          $emit('on-change-focus');
          $emit('on-set-focus', true);
        }
      "
      @blur="$emit('on-set-focus', false)"
      :disabled="$store.state.aiChat.textareaIsDisabled"
    >
    </el-input>
  </div>
</template>

<script>
export default {
  name: "TextareaOne",
  props: {
    valueProp: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      value: "",
      initialValue: this.valueProp,
    };
  },
  methods: {
    onFocus() {
      this.$refs.customInput.focus();
    },

    onKeyCode(event) {
      if (event.ctrlKey && event.keyCode == 13) {
        // ctrl+enter 换行
        const userAgent = navigator.userAgent;
        //Safari浏览器ctrl+enter会有默认换行，所以要阻止默认事件
        if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
          event.preventDefault();
        }
        this.value = this.value + "\n";

        this.$nextTick(() => {
          const input = this.$el.querySelector(".el-textarea__inner");
          input.scrollTop = input.scrollHeight;
        });

        // this.$emit("on-change-content");
      } else if (event.keyCode == 13) {
        // 回车发送
        if (!event.metaKey) {
          event.preventDefault();

          this.$emit("on-key-up-enter", this.value);
        }
      }
    },
  },
  watch: {
    value: {
      handler: function (n) {
        if (this.$attrs.isSync !== undefined ? this.$attrs.isSync : true) {
          this.$emit("update:valueProp", n);
        } else {
          this.$emit("on-change", n);
        }
      },
    },
    valueProp: {
      handler: function (n) {
        this.value = n;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-textarea_one {
  line-height: 1;
  .c-template_input {
    ::v-deep {
      &.el-textarea {
        .el-textarea__inner {
          border: 0;
          padding: 0;
          scrollbar-width: auto;
          &::-webkit-scrollbar {
            width: 5px;
          }

          &::-webkit-scrollbar-thumb {
            border-radius: 3px;
            background: #c9cdd4 !important;
          }

          &::-webkit-scrollbar-track {
          }

          font-size: 12px;
          color: #1d2129;
          line-height: 17px;
          &::placeholder {
            font-size: 12px;
            color: #86909c;
            line-height: 17px;
          }
        }
        .el-input__wrap:hover
          .el-textarea__inner:not([readonly="readonly"]):not(
            [disabled="disabled"]
          ) {
          border: 0;
        }
      }
      .el-input {
        .el-input__wrap {
          .el-input__inner {
            border: 0;
            padding: 0;
            height: auto;
            line-height: normal;
          }
        }
      }
    }
  }
}
</style>